export const AUTOCOMPLETE = 'autocomplete';
export const AUTOCOMPLETE_SELECTED = 'autocomplete--selected';
